import { Newspaper } from "lucide-react";
import { useLang } from "@/i18n";
import Reveal from "@/components/Reveal";

const PRESS_IMG =
  "https://images.unsplash.com/photo-1696881333324-922bf5956460?auto=format&fit=crop&q=85&w=1600";

export default function Press() {
  const { t } = useLang();
  const p = t.press;

  return (
    <section id="presse" data-testid="press-section" className="relative scroll-mt-24 overflow-hidden">
      <img
        src={PRESS_IMG}
        alt="Crêtes du massif de Belledonne dans la brume"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-pine-deep/70" />
      <div className="relative mx-auto max-w-4xl px-5 py-28 text-center md:px-10 md:py-40">
        <Reveal>
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full border border-paper/25 text-paper/80">
            <Newspaper size={22} />
          </div>
          <p className="mt-8 text-xs font-semibold uppercase tracking-[0.28em] text-wood-light">
            {p.eyebrow}
          </p>
          <h2
            data-testid="press-message"
            className="mt-6 font-serif text-4xl font-light italic tracking-tight text-paper md:text-6xl"
          >
            {p.line}
          </h2>
          <p className="mt-6 text-base text-paper/75 md:text-lg">{p.sub}</p>
        </Reveal>
      </div>
    </section>
  );
}
